import React from 'react'

class Category extends React.Component {
  render() {
    const category = this.props.data.category
    const slug = this.props.data.slug
    const href = this.props.data.href
    const color = this.props.data.color
    const description = this.props.data.description
    if (href) {
      return (
        <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3">
          <div
            style={{ boxShadow: 'none', background: color }}
            className="text-center p-12  h-full  text-black rounded"
          >
            <a
              href={href}
              className="block no-underline text-black text-xl mb-2 font-bold pb-6"
            >
              {category}
            </a>

            {/* <Link style={{ boxShadow: 'none' }} to={slug}>
          {category}
        </Link> */}

            {/* <small>{node.frontmatter.date}</small> */}
            {/* <p dangerouslySetInnerHTML={{ __html: node.excerpt }} /> */}
            <div>{description}</div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3">
          <div
            style={{ boxShadow: 'none', background: color }}
            color={color}
            className="text-center p-12  h-full  text-black rounded"
          >
            <a
              href={slug}
              className="block no-underline text-black text-xl mb-2 font-bold pb-6"
            >
              {category}
            </a>

            {/* <Link style={{ boxShadow: 'none' }} to={slug}>
          {category}
        </Link> */}

            {/* <small>{node.frontmatter.date}</small> */}
            {/* <p dangerouslySetInnerHTML={{ __html: node.excerpt }} /> */}
            <div>{description}</div>
          </div>
        </div>
      )
    }
  }
}

export default Category
